export default {
    baseStyle: {
        // General Payment Container
        '.payment .adyen-checkout__dropin': {
            padding: '0 0 32px 0'
        },

        // Payment Method (Common)
        '.payment .adyen-checkout__payment-method': {
            border: 0,
            backgroundColor: 'white'
        },
        '.payment .adyen-checkout__payment-method__name': {
            textTransform: 'uppercase',
            fontWeight: 700,
        },
        '.payment .adyen-checkout__payment-method__header': {
            padding: 0,
            fontSize: '14px'
        },
        '.payment .adyen-checkout__payment-method__radio': {
            width: '18px',
            height: '18px',
            backgroundColor: 'white',
            border: '1px solid black',
            order: 1,
            '&::after': {
                backgroundColor: 'black',
                top: '8px',
                width: '12px',
                height: '12px',
            }
        },
        '.payment .adyen-checkout__payment-method__brands': {
            display: 'none'
        },
        '.payment .adyen-checkout__payment-method__image__wrapper': {
            order: 3,
            boxShadow: 'none',
            width: '90px',
            height: '29px',
            justifyContent: 'flex-start'
        },
        '.adyen-checkout__payment-method--scheme .adyen-checkout__payment-method__image__wrapper': {
            '&::after': {
                content: '""',
                display: 'block',
                background: `url("data:image/svg+xml,%3Csvg%20width%3D%2289%22%20height%3D%2218%22%20viewBox%3D%220%200%2089%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Crect%20x%3D%2262%22%20width%3D%2227%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22white%22/%3E%3Crect%20x%3D%2262.5%22%20y%3D%220.5%22%20width%3D%2226%22%20height%3D%2217%22%20rx%3D%221.5%22%20stroke%3D%22black%22%20stroke-opacity%3D%220.2%22/%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M88.74%2013.35V15.306H86.256L85.338%2014.232L84.384%2015.306H77.328V9.588H75L77.91%203H80.742L81.426%204.494V3H84.942L85.53%204.566L86.106%203H88.74V3.92999H86.706L85.782%206.36601L85.536%207.02599L84.354%203.92999H82.32V8.72998L80.208%203.92999H78.57L76.446%208.72998H77.838L78.21%207.806H80.538L80.91%208.72998H82.32H83.544V5.604L83.538%204.97399L83.778%205.604L84.948%208.72998H86.112L87.288%205.604L87.516%204.98V8.72998H88.74V10.608L87.384%2011.97L88.74%2013.35ZM78.312%2014.376V9.59397H82.32V10.632H79.536V11.472H82.266V12.504H79.536V13.338H82.32V14.376H78.312ZM88.368%2014.376H86.778L85.326%2012.816L83.868%2014.376H82.32L84.558%2011.994L82.32%209.59397H83.916L85.356%2011.148L86.802%209.59397H88.368L86.124%2011.976L88.368%2014.376Z%22%20fill%3D%22%23016FD0%22/%3E%3Cpath%20d%3D%22M79.374%204.95599L79.134%205.55601L78.636%206.76798H80.112L79.614%205.55601L79.374%204.95599Z%22%20fill%3D%22%23016FD0%22/%3E%3Crect%20width%3D%2227%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22white%22/%3E%3Crect%20x%3D%220.5%22%20y%3D%220.5%22%20width%3D%2226%22%20height%3D%2217%22%20rx%3D%221.5%22%20stroke%3D%22black%22%20stroke-opacity%3D%220.2%22/%3E%3Cpath%20d%3D%22M16.6781%205.48633C15.187%205.48633%2013.8545%206.25918%2013.8545%207.68709C13.8545%209.32464%2016.2177%209.43774%2016.2177%2010.2604C16.2177%2010.6068%2015.8208%2010.9169%2015.1428%2010.9169C14.1806%2010.9169%2013.4614%2010.4836%2013.4614%2010.4836L13.1537%2011.9245C13.1537%2011.9245%2013.9822%2012.2905%2015.0821%2012.2905C16.7123%2012.2905%2017.9951%2011.4797%2017.9951%2010.0274C17.9951%208.297%2015.622%208.18725%2015.622%207.42369C15.622%207.15235%2015.9479%206.85504%2016.6239%206.85504C17.3867%206.85504%2018.009%207.17014%2018.009%207.17014L18.3102%205.77845C18.3102%205.77845%2017.633%205.48633%2016.6781%205.48633ZM3.03611%205.59136L3%205.80143C3%205.80143%203.6273%205.91623%204.19229%206.14525C4.91975%206.40785%204.97158%206.56073%205.09409%207.03556L6.42916%2012.1822H8.21882L10.9759%205.59136H9.19037L7.41876%2010.0725L6.69584%206.27407C6.62954%205.83935%206.29372%205.59136%205.88266%205.59136H3.03611ZM11.6939%205.59136L10.2932%2012.1822H11.9959L13.3917%205.59136H11.6939ZM21.1904%205.59136C20.7798%205.59136%2020.5623%205.81118%2020.4026%206.1953L17.9081%2012.1822H19.6937L20.0391%2011.1844H22.2144L22.4245%2012.1822H24L22.6255%205.59136H21.1904ZM21.4226%207.372L21.9519%209.84519H20.5339L21.4226%207.372Z%22%20fill%3D%22%231434CB%22/%3E%3Crect%20x%3D%2231%22%20width%3D%2227%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22white%22/%3E%3Crect%20x%3D%2231.5%22%20y%3D%220.5%22%20width%3D%2226%22%20height%3D%2217%22%20rx%3D%221.5%22%20stroke%3D%22black%22%20stroke-opacity%3D%220.2%22/%3E%3Cpath%20d%3D%22M42.2021%204.81641H46.7987V13.0756H42.2021V4.81641Z%22%20fill%3D%22%23FF5F00%22/%3E%3Cpath%20d%3D%22M42.4936%208.94658C42.4936%207.26847%2043.2815%205.78006%2044.4927%204.81697C43.6026%204.11654%2042.479%203.69336%2041.2532%203.69336C38.3494%203.69336%2036%206.04272%2036%208.94658C36%2011.8504%2038.3494%2014.1998%2041.2532%2014.1998C42.479%2014.1998%2043.6026%2013.7766%2044.4927%2013.0762C43.2815%2012.1277%2042.4936%2010.6247%2042.4936%208.94658Z%22%20fill%3D%22%23EB001B%22/%3E%3Cpath%20d%3D%22M52.9995%208.94658C52.9995%2011.8504%2050.6502%2014.1998%2047.7463%2014.1998C46.5206%2014.1998%2045.397%2013.7766%2044.5068%2013.0762C45.7326%2012.1131%2046.506%2010.6247%2046.506%208.94658C46.506%207.26847%2045.718%205.78006%2044.5068%204.81697C45.397%204.11654%2046.5206%203.69336%2047.7463%203.69336C50.6502%203.69336%2052.9995%206.05731%2052.9995%208.94658Z%22%20fill%3D%22%23F79E1B%22/%3E%3C/svg%3E") no-repeat center center/89px`,
                top: '2px',
                width: '90px',
                height: '29px',
                position: 'absolute'
            }
        },
        '.adyen-checkout__payment-method--scheme .adyen-checkout__payment-method__image': {
            visibility: 'hidden'
        },
        '.payment .adyen-checkout__payment-method__image': {
            transform: 'scale(1.8)',
            width: '70px'
        },
        '.payment .adyen-checkout__payment-method__name_wrapper': {
            order: 2
        },
        '.payment .adyen-checkout__store-details': {
            border: 0,
            paddingLeft: 0
        },
        '.payment .adyen-checkout__store-details .adyen-checkout__checkbox__label': {
            '&::after': {
                borderRadius: 0
            }
        },
        '.payment .adyen-checkout__card__brands': {
            display: 'none'
        },
        '.payment .adyen-checkout__field--cardNumber': {
            '@media (min-width: 992px)': {
                width: '343px',
            }
        },
        '.payment .adyen-checkout__field-wrapper': {
            '@media (min-width: 992px)': {
                width: '343px',
            }
        },

        // Klarna Specific Styles
        '.has-gc .adyen-checkout__payment-method--klarna': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.has-gc-products .adyen-checkout__payment-method--klarna': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaProductMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.has-gc .adyen-checkout__payment-method--klarna_account': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.has-gc-products .adyen-checkout__payment-method--klarna_account': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaProductMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.adyen-checkout__payment-method--klarna .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },
        '.adyen-checkout__payment-method--klarna .adyen-checkout__button__text': {
            whiteSpace: 'break-spaces'
        },
        '.adyen-checkout__payment-method--klarna_account .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },

        // PayPal Specific Styles
        '.adyen-checkout__payment-method--paypal .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },
        '.payment .adyen-checkout__payment-method--paypal .adyen-checkout__payment-method__image__wrapper':
        {
            width: '108px',
            gap: '8px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            '&::after': {
                content: '""',
                display: 'block',
                width: '70px',
                height: '20px',
                background:
                    'url("data:image/svg+xml,%3Csvg%20width%3D%2266%22%20height%3D%2217%22%20viewBox%3D%220%200%2066%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%3Cg%20clip-path%3D%22url(%23clip0_2536_2041)%22%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M51.2496%206.9716C51.0612%208.2636%2050.0652%208.2636%2049.0962%208.2636H48.5579L48.9347%205.84109C48.9617%205.70651%2049.0962%205.59884%2049.2308%205.59884H49.4731C50.1191%205.59884%2050.7382%205.59884%2051.0612%205.97567C51.2765%206.19101%2051.3303%206.51401%2051.2496%206.9716ZM50.8458%203.58008H47.2121C46.9698%203.58008%2046.7545%203.7685%2046.7007%204.01075L45.2202%2013.324C45.1933%2013.5124%2045.3279%2013.6739%2045.5163%2013.6739H47.3736C47.5351%2013.6739%2047.6966%2013.5393%2047.7235%2013.3778L48.1272%2010.7399C48.1542%2010.4977%2048.3695%2010.3093%2048.6387%2010.3093H49.7961C52.1917%2010.3093%2053.5644%209.15186%2053.9144%206.86393C54.0759%205.86801%2053.9144%205.0605%2053.4568%204.52217C52.9723%203.90308%2052.0571%203.58008%2050.8458%203.58008Z%22%20fill%3D%22%232790C3%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M25.3555%206.9716C25.1671%208.2636%2024.1712%208.2636%2023.2022%208.2636H22.6639L23.0407%205.84109C23.0676%205.70651%2023.2022%205.59884%2023.3368%205.59884H23.579C24.225%205.59884%2024.8441%205.59884%2025.1671%205.97567C25.3825%206.19101%2025.4363%206.51401%2025.3555%206.9716ZM24.9518%203.58008H21.318C21.0758%203.58008%2020.8604%203.7685%2020.8066%204.01075L19.3262%2013.324C19.2993%2013.5124%2019.4339%2013.6739%2019.6223%2013.6739H21.3449C21.5872%2013.6739%2021.8025%2013.4855%2021.8564%2013.2432L22.2601%2010.7399C22.287%2010.4977%2022.5024%2010.3093%2022.7715%2010.3093H23.929C26.3246%2010.3093%2027.6973%209.15186%2028.0472%206.86393C28.2087%205.86801%2028.0472%205.0605%2027.5896%204.52217C27.0782%203.90308%2026.163%203.58008%2024.9518%203.58008Z%22%20fill%3D%22%2327346A%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M33.3767%2010.3094C33.2152%2011.3053%2032.4077%2011.9782%2031.4118%2011.9782C30.9003%2011.9782%2030.4966%2011.8167%2030.2543%2011.5206C29.9852%2011.2245%2029.9044%2010.7939%2029.9852%2010.3094C30.1467%209.31344%2030.9542%208.64052%2031.9232%208.64052C32.4077%208.64052%2032.8114%208.80202%2033.0806%209.12503C33.3498%209.39419%2033.4574%209.85178%2033.3767%2010.3094ZM35.7992%206.94476H34.0496C33.8881%206.94476%2033.7804%207.05243%2033.7535%207.18702L33.6728%207.67152L33.5382%207.4831C33.1614%206.94476%2032.3269%206.75635%2031.4925%206.75635C29.5814%206.75635%2027.9395%208.20985%2027.6165%2010.2555C27.455%2011.2784%2027.6973%2012.2474%2028.2625%2012.9203C28.8008%2013.5394%2029.5545%2013.8085%2030.4428%2013.8085C32.0039%2013.8085%2032.8384%2012.8126%2032.8384%2012.8126L32.7576%2013.2971C32.7307%2013.4855%2032.8653%2013.647%2033.0537%2013.647H34.6149C34.8571%2013.647%2035.0725%2013.4586%2035.1263%2013.2164L36.0684%207.26777C36.1222%207.10627%2035.9876%206.94476%2035.7992%206.94476Z%22%20fill%3D%22%2327346A%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M59.2707%2010.3094C59.1092%2011.3053%2058.3017%2011.9782%2057.3058%2011.9782C56.7944%2011.9782%2056.3906%2011.8167%2056.1484%2011.5206C55.8792%2011.2245%2055.7985%2010.7939%2055.8792%2010.3094C56.0407%209.31344%2056.8482%208.64052%2057.8172%208.64052C58.3017%208.64052%2058.7055%208.80202%2058.9747%209.12503C59.2438%209.39419%2059.3515%209.85178%2059.2707%2010.3094ZM61.6932%206.94476H59.9437C59.7822%206.94476%2059.6745%207.05243%2059.6476%207.18702L59.5668%207.67152L59.4322%207.4831C59.0554%206.94476%2058.221%206.75635%2057.3866%206.75635C55.4755%206.75635%2053.8335%208.20985%2053.5105%2010.2555C53.349%2011.2784%2053.5913%2012.2474%2054.1565%2012.9203C54.6949%2013.5394%2055.4486%2013.8085%2056.3368%2013.8085C57.898%2013.8085%2058.7324%2012.8126%2058.7324%2012.8126L58.6516%2013.2971C58.6247%2013.4855%2058.7593%2013.647%2058.9477%2013.647H60.5089C60.7512%2013.647%2060.9665%2013.4586%2061.0203%2013.2164L61.9624%207.26777C62.0163%207.10627%2061.8817%206.94476%2061.6932%206.94476Z%22%20fill%3D%22%232790C3%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M45.0587%206.94434H43.3091C43.1476%206.94434%2042.9861%207.02509%2042.9053%207.15967L40.4828%2010.7127L39.46%207.29425C39.4061%207.07892%2039.1908%206.94434%2038.9755%206.94434H37.2528C37.0374%206.94434%2036.9029%207.15967%2036.9567%207.34809L38.8678%2013.0006L37.0644%2015.5577C36.9298%2015.7461%2037.0644%2016.0422%2037.3066%2016.0422H39.0562C39.2177%2016.0422%2039.3792%2015.9615%2039.46%2015.8269L45.274%207.42884C45.4355%207.2135%2045.3009%206.94434%2045.0587%206.94434Z%22%20fill%3D%22%2327346A%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M63.7392%203.84925L62.2588%2013.324C62.2319%2013.5124%2062.3665%2013.6739%2062.5549%2013.6739H64.0622C64.3045%2013.6739%2064.5198%2013.4855%2064.5736%2013.2432L66.0541%203.93C66.081%203.74158%2065.9464%203.58008%2065.758%203.58008H64.0891C63.8738%203.58008%2063.7661%203.68775%2063.7392%203.84925Z%22%20fill%3D%22%232790C3%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M6.86356%2015.3695L7.34807%2012.2741L7.37498%2012.1126C7.4019%2011.9511%207.48265%2011.8165%207.59032%2011.7357C7.69798%2011.6281%207.85949%2011.5742%207.99407%2011.5742H8.3709C9.01691%2011.5742%209.60908%2011.4935%2010.1474%2011.3589C10.7127%2011.2243%2011.1972%2010.9821%2011.6278%2010.686C12.0854%2010.363%2012.4623%209.95922%2012.7314%209.47471C13.0544%208.96329%2013.2698%208.31729%2013.4043%207.61745C13.5389%206.99837%2013.5389%206.43312%2013.4851%205.94861C13.4043%205.43719%2013.2159%205.00653%2012.8929%204.65661C12.7045%204.44127%2012.4623%204.25285%2012.1931%204.11827C12.3008%203.49918%2012.3008%202.96085%2012.1931%202.50326C12.0854%202.04568%2011.8701%201.64192%2011.5202%201.26509C10.8472%200.430669%209.58216%200%207.75182%200H2.77221C2.61071%200%202.44921%200.0807504%202.31462%200.188418C2.18004%200.296085%202.09929%200.457586%202.07237%200.619086L0.0266954%2013.7545C-0.000221439%2013.8622%200.0266954%2013.9967%200.107446%2014.0775C0.188196%2014.1582%200.295863%2014.2121%200.430447%2014.2121H3.52588V14.239L3.31055%2015.5848C3.28363%2015.6925%203.33746%2015.8002%203.3913%2015.8809C3.47205%2015.9617%203.5528%2016.0155%203.66046%2016.0155H6.24448C6.37906%2016.0155%206.54056%2015.9617%206.64823%2015.8809C6.7559%2015.8002%206.83665%2015.6656%206.86356%2015.5041V15.3695Z%22%20fill%3D%22%2327346A%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M5.1142%204.09135C5.14111%203.87602%205.2757%203.71452%205.46411%203.63377C5.54486%203.60685%205.62561%203.57993%205.73328%203.57993H9.63622C10.0938%203.57993%2010.5245%203.60685%2010.9282%203.66069C11.0359%203.6876%2011.1436%203.6876%2011.2512%203.71452C11.3589%203.74144%2011.4666%203.76835%2011.5742%203.79527C11.6281%203.82219%2011.6819%203.82219%2011.7088%203.8491C11.8972%203.90294%2012.0856%203.98369%2012.2471%204.06444C12.4356%202.82626%2012.2471%201.96493%2011.5742%201.21126C10.8206%200.349918%209.47472%200%207.75204%200H2.77243C2.42252%200%202.12643%200.242251%202.0726%200.59217L3.65451e-06%2013.7545C-0.0538299%2014.0237%200.161504%2014.239%200.430672%2014.239H3.49919L5.1142%204.09135Z%22%20fill%3D%22%2327346A%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.2201%204.06445C12.1931%204.17212%2012.1931%204.25287%2012.1662%204.36054C11.5202%207.72514%209.25922%208.90948%206.40603%208.90948H4.95253C4.60261%208.90948%204.30652%209.15173%204.25269%209.50165L3.28369%2015.5848C3.25677%2015.8002%203.41827%2016.0155%203.66052%2016.0155H6.24453C6.54062%2016.0155%206.80979%2015.8002%206.86362%2015.4772L6.89054%2015.3426L7.37504%2012.2472L7.40196%2012.0857C7.45579%2011.7896%207.69804%2011.5473%208.02104%2011.5473H8.39788C10.9011%2011.5473%2012.8661%2010.5245%2013.4582%207.59055C13.7005%206.35238%2013.5659%205.32954%2012.9468%204.60279C12.7584%204.38745%2012.5161%204.22595%2012.2201%204.06445Z%22%20fill%3D%22%232790C3%22%2F%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M11.5474%203.79541C11.4398%203.7685%2011.3321%203.74158%2011.2244%203.71466C11.1168%203.68775%2011.0091%203.66083%2010.9014%203.66083C10.4977%203.60699%2010.067%203.58008%209.60943%203.58008H5.7065C5.59883%203.58008%205.51808%203.60699%205.43733%203.63391C5.24891%203.71466%205.11433%203.90308%205.08741%204.0915L4.25299%209.34027L4.22607%209.50177C4.27991%209.15186%204.57599%208.9096%204.92591%208.9096H6.37942C9.25952%208.9096%2011.4936%207.75218%2012.1396%204.36067C12.1665%204.253%2012.1665%204.17225%2012.1934%204.06458C12.0319%203.98383%2011.8435%203.90308%2011.6551%203.84925C11.6551%203.82233%2011.6013%203.82233%2011.5474%203.79541Z%22%20fill%3D%22%231F264F%22%2F%3E%20%3C%2Fg%3E%20%3Cdefs%3E%20%3CclipPath%20id%3D%22clip0_2536_2041%22%3E%20%3Crect%20width%3D%2266%22%20height%3D%2216.0155%22%20fill%3D%22white%22%2F%3E%20%3C%2FclipPath%3E%20%3C%2Fdefs%3E%20%3C%2Fsvg%3E") no-repeat left center/contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left center',
                backgroundSize: 'contain',
                flexShrink: 0
            }
        },
        '.payment .adyen-checkout__paypal__buttons': {
            '@media (min-width: 992px)': {
                maxWidth: '343px',
            }
        },
        '.payment .adyen-checkout__payment-method--paypal .adyen-checkout__payment-method__image': {
            display: 'none'
        },

        // Apple Pay Specific Styles
        '.adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },
        '.payment .adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__image': {
            transform: 'scale(1)',
            width: '45px'
        },
        'apple-pay-button': {
            display: 'block',
            '--apple-pay-button-height': '48px',
            '--apple-pay-button-border-radius': '0',
            '@media (min-width: 992px)': {
                maxWidth: '343px',
                '--apple-pay-button-width': '343px'
            }
        },

        // Input and Field Styling
        '.payment .adyen-checkout__input-wrapper': {
            fontFamily: 'HelveticaNeueLTStd-Form',
            borderTop: 0,
            borderRight: 0,
            borderBottom: '1px solid gray.800',
            borderLeft: 0,
            borderRadius: 0,
            boxShadow: 'none !important'
        },
        '.payment .adyen-checkout__input': {
            paddingLeft: 0
        },
        '.payment .adyen-checkout__payment-method__details': {
            padding: 0
        },
        '.payment .adyen-checkout__payment-method__details__content': {
            marginTop: '20px'
        },
        '.payment .adyen-checkout__label__text': {
            display: 'none'
        },

        // Submit Button
        '.payment .adyen-checkout__button ': {
            borderRadius: 0,
            backgroundColor: 'black',
            textTransform: 'uppercase',
            '@media (min-width: 992px)': {
                minWidth: '343px',
                width: 'auto',
                padding: '0 30px',
            }
        },

        // Card Specific Adjustments
        '.payment .adyen-checkout__card__cardNumber__brandIcon': {
            display: 'none'
        },
        '.payment .adyen-checkout__card__form': {
            '@media (min-width: 992px)': {
                width: '343px'
            }
        },
        '.payment .adyen-checkout__card__holderName': {
            '@media (min-width: 992px)': {
                width: '343px'
            }
        },

        // Hiding Miscellaneous Elements
        '.payment .adyen-checkout-form-instruction': {
            display: 'none'
        },
        '.payment .adyen-checkout__field__exp-date_hint_wrapper': {
            display: 'none'
        },
        '.payment .adyen-checkout-contextual-text': {
            display: 'none'
        },

        // Saved CC Specific Styles
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__payment-method__image':
            {
                transform: 'scale(0.7)',
                width: '45px',
                height: '100%',
                visibility: 'visible'
            },
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__payment-method__image__wrapper':
            {
                width: '40px',
                '&::after': {
                    display: 'none'
                }
            },
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__payment-method__name_wrapper':
            {
                order: 3
            },
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__field--inactive':
            {
                pointerEvents: 'none'
            },
         '.adyen-checkout__paywithgoogle': {
            width: '100%',

            '@media (min-width: 992px)': {
                width: '343px'
            }
        },
        '.adyen-checkout__payment-method--googlepay .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },
        '.adyen-checkout__payment-method--googlepay .adyen-checkout__payment-method__image.adyen-checkout__image.adyen-checkout__image--loaded':
            {
                width: '60px !important',
                height: '19px !important',
                marginLeft: '-4px'
            },
        '.gpay-card-info-container': {
            'border-radius': '0px'
        }
    }
}
